/*----------------------------------
- HOOK: USE REDUCED MOTION PREFERENCE
----------------------------------*/

import React from 'react';

const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

// SSR-safe prefers-reduced-motion read. Components that only need the boolean
// use this instead of Motion's useReducedMotion so they do not pull
// framer-motion into their chunk.
export default function useReducedMotionPreference(): boolean {
    const [prefersReducedMotion, setPrefersReducedMotion] = React.useState(
        () => typeof window !== 'undefined' && window.matchMedia(REDUCED_MOTION_QUERY).matches,
    );

    React.useEffect(() => {
        const media = window.matchMedia(REDUCED_MOTION_QUERY);
        const syncPreference = () => setPrefersReducedMotion(media.matches);
        media.addEventListener('change', syncPreference);
        return () => media.removeEventListener('change', syncPreference);
    }, []);

    return prefersReducedMotion;
}
